export default "__VITE_ASSET__CDMOmGad__"